'use client'

import { hasAcceptedCookies } from '@/lib/client/cookies'
import { GoogleTagManager } from '@next/third-parties/google'
import React, { Suspense } from 'react'
import DonatePopup from '@/components/DonatePopup/Component'
import AppStorageEffect from '@/lib/client/app-storage/AppStorageEffect'
import CookieConsent from '@/components/CookieConsent'
import ServiceWorkerRegistration from '@/lib/client/registerServiceWorker'

export default function RootLayoutClient(
  {children, gtmId}: {
    children: React.ReactNode
    gtmId: string
  }) {
  return <>
    {hasAcceptedCookies() && (
      <GoogleTagManager gtmId={gtmId} />
    )}

    {children}

    <DonatePopup />
    <Suspense fallback={null}>
      <AppStorageEffect />
      <ServiceWorkerRegistration />
    </Suspense>
    <CookieConsent />
  </>
}
